module.exports = __webpack_public_path__ + "img/product-shot_05.72b003a6.jpg";